// Configuration for the tiered group size discount feature.
// To launch a new campaign, update the values below and set enabled to true.
// No other code changes should be necessary.

export interface DiscountTier {
	readonly threshold: number;
	readonly rate: number;
	readonly label: string;
}

export interface PromoCodeMapping {
	readonly minPlayers: number;
	readonly maxPlayers: number;
	readonly code: string;
}

export interface TieredGroupSizeDiscountConfig {
	/** Master switch - set to true to activate the feature */
	readonly enabled: boolean;

	/** Ordered discount tiers (lowest threshold first) */
	readonly tiers: ReadonlyArray<DiscountTier>;

	/** Promo codes to auto-apply based on player count ranges */
	readonly promoCodes: ReadonlyArray<PromoCodeMapping>;

	/** All promo codes managed by this feature (used to clean up when clearing) */
	readonly allCampaignCodes: ReadonlyArray<string>;

	/** Restrict to this attractionTypeId, or undefined for all attraction types */
	readonly attractionTypeId: number | undefined;

	/** Whether the discount is per-slot (true) or per-booking (false) for price estimation */
	readonly isPerSlot: boolean;
}

// ============================================================
// CURRENT CAMPAIGN VALUES -- edit these for each new campaign
// ============================================================

export const DISCOUNT_TIERS: ReadonlyArray<DiscountTier> = [
	{ threshold: 4, rate: 0.20, label: '20%' },
	{ threshold: 6, rate: 0.25, label: '25%' },
];

const PROMO_CODE_MAPPINGS: ReadonlyArray<PromoCodeMapping> = [
	{ minPlayers: 4, maxPlayers: 5, code: 'MAY26P4U' },
	{ minPlayers: 6, maxPlayers: 10, code: 'MAY26P6U' },
];

export const CAMPAIGN_CONFIG: TieredGroupSizeDiscountConfig = {
	enabled: false,
	tiers: DISCOUNT_TIERS,
	promoCodes: PROMO_CODE_MAPPINGS,
	allCampaignCodes: PROMO_CODE_MAPPINGS.map((m) => m.code),
	attractionTypeId: 1,
	isPerSlot: true,
};
